import injectSaga from '../../../hocs/redux/injectSaga';
import withUniqueId from '../../../hocs/helpers/_withUniqueId';

import compose from '../../../utils/components/_compose';
import Saga, { SagaComposedProps, SagaProps } from './Saga';

export * from './Saga';

const ComposedSaga: <Props>(props: SagaProps & Props) => null = compose<any>(
  withUniqueId('sagaId'),
  injectSaga<SagaComposedProps>({
    key: ({ sagaId }) => `Saga${sagaId}`,
    sagaFactory: ({ saga }) => saga,
  }),
)(Saga);

export default ComposedSaga;
